import { useEffect, useState } from "react";
import { PageHeader } from "../components/Primitives";
import { api, errorText, formatDate } from "../lib/api";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/audit-logs").then((res) => setLogs(res.data.data)).catch((err) => setError(errorText(err)));
  }, []);

  return (
    <div className="page-enter">
      <PageHeader eyebrow="SECURITY" title="Activity log" description="Every meaningful action, by user and timestamp." />
      {error ? <div className="error-message">{error}</div> : null}
      <section className="content-card table-card">
        <div className="table-wrap">
          <table data-testid="audit-table">
            <thead>
              <tr><th>When</th><th>User</th><th>Role</th><th>Action</th><th>Entity</th></tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id}>
                  <td>{formatDate(log.created_at)}</td>
                  <td>{log.user_name}</td>
                  <td>{log.role}</td>
                  <td>{log.action}</td>
                  <td>{log.entity} {log.entity_id ? `· ${log.entity_id.slice(0, 8)}` : ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
